// extracted by mini-css-extract-plugin
export default {"dim":"DimModalLayout_dim__txiUq","layout":"DimModalLayout_layout__kqcI7"};